import React from 'react';
import PropTypes from 'prop-types';
import {
  FileDropzone,
  InputText,
  Radio,
  Textarea,
} from '@othermachines/react-form-kit';

import {
  Fieldset,
  FileDropzoneCloser,
} from '../../../Shared';

import {
  allowedFileTypesString,
  inputTheme,
  inputThemeShort,
  maxFileSize,
  radioTheme,
  textareaTheme,
} from '../../../lib';


const formName = 'Dimensional Letters and Logos';

const defaultValues = {
  'Thickness': '',
  'Character-height': '',
  'Material': '',
  'Colours': '',
  'Text': '',
  'Graphic': '',
  'Attachments': '',
  'Wall-type': '',
  'Size-area': '',
  'Installation-required': '',
};

const fields = [
  'Thickness',
  'Character-height',
  'Material',
  'Colours',
  'Text',
  'Graphic',
  'Attachments',
  'Wall-type',
  'Size-area',
  'Installation-required',
];

const Component = ({
  submitForm: {
    control,
    formState,
    register,
    setValue,
    unregister,
    watch,
  },

}) => {

  return (
    <Fieldset legend={formName}>

      <InputText
        inputTextId='Thickness'
        inputTextName='Thickness'
        register={register}
        formState={formState}
        label='Desired thickness of signage'
        theme={inputThemeShort}
      />

      <InputText
        inputTextId='Character-height'
        inputTextName='Character-height'
        register={register}
        formState={formState}
        label='Desired height of characters'
        theme={inputThemeShort}
      />

      <Radio
        radioId='Material'
        radioName='Material'
        legend='Material'
        options={[
          { value: 'metal', label: 'Metal' },
          { value: 'acrylic', label: 'Acrylic' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />

      <InputText
        inputTextId='Colours'
        inputTextName='Colours'
        register={register}
        formState={formState}
        label='Colours'
        theme={inputTheme}
      />

      <Textarea
        textareaId='Text'
        textareaName='Text'
        register={register}
        formState={formState}
        label='Text'
        theme={textareaTheme}
      />

      <Textarea
        textareaId='Graphic'
        textareaName='Graphic'
        register={register}
        formState={formState}
        label='Brief description of graphic, if applicable'
        theme={textareaTheme}
      />

      <FileDropzone
        fileId='Attachments'
        fileName='Attachments'
        label='Please attach any graphic files'
        register={register}
        unregister={unregister}
        setValue={setValue}
        control={control}
        watch={watch}
        formState={formState}
        allowedExtensions={allowedFileTypesString}
        maxFileSize={maxFileSize}
      >
        <FileDropzoneCloser />
      </FileDropzone>


      <InputText
        inputTextId='Wall-type'
        inputTextName='Wall-type'
        register={register}
        formState={formState}
        label='Type of wall'
        theme={inputTheme}
      />

      <InputText
        inputTextId='Size-area'
        inputTextName='Size-area'
        register={register}
        formState={formState}
        label='Size of area'
        theme={inputTheme}
      />

      <Radio
        radioId='Installation-required'
        radioName='Installation-required'
        legend='Do you require installation?'
        options={[
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />
    </Fieldset>
  );
};

Component.propTypes = {
  submitForm: PropTypes.shape({
    control: PropTypes.object.isRequired,
    formState: PropTypes.object.isRequired,
    register: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    unregister: PropTypes.func.isRequired,
    watch: PropTypes.func.isRequired,
  }).isRequired,
};

export default Component;
export { defaultValues, fields, formName };
